"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = void 0;

var react_1 = require("react");
/**
 * @ignore
 */


var context = (0, react_1.createContext)({
  flags: {},
  flagKeyMap: {},
  ldClient: undefined
});
var Provider = context.Provider,
    Consumer = context.Consumer;
exports.Provider = Provider;
exports.Consumer = Consumer;
exports.default = context;